export var ApiKeyTypes;
(function (ApiKeyTypes) {
    ApiKeyTypes["classic"] = "classic";
    ApiKeyTypes["buddy"] = "buddy";
})(ApiKeyTypes || (ApiKeyTypes = {}));
export var ServiceActionTypes;
(function (ServiceActionTypes) {
    ServiceActionTypes["apiKeys"] = "api_keys";
    ServiceActionTypes["apiKeysLimit"] = "api_keys_limit";
    ServiceActionTypes["createApi"] = "create_api";
    ServiceActionTypes["changeApiName"] = "change_api_name";
    ServiceActionTypes["manegeApi"] = "manage_api";
    ServiceActionTypes["deleteApi"] = "delete_api";
})(ServiceActionTypes || (ServiceActionTypes = {}));
export var ApiKeysAsideModes;
(function (ApiKeysAsideModes) {
    ApiKeysAsideModes["default"] = "default";
    ApiKeysAsideModes["create"] = "create";
    ApiKeysAsideModes["edit"] = "edit";
})(ApiKeysAsideModes || (ApiKeysAsideModes = {}));
